import React from "react";

import "./ItemTagLabels.scss";

interface ItemTagLabelsProps {
	tags: string[] | null;
}

const ItemTagLabels: React.FC<ItemTagLabelsProps> = ({ tags }) => {
	if (!tags) return null;

	const labelTags = tags.filter((tag) => tag.startsWith("label-"));

	if (labelTags.length === 0) return null;

	return (
		<div className="ItemTagLabels">
			{labelTags.map((tag, index) => {
				const labelText = tag.replace("label-", "");

				return (
					<span key={index} className="ItemTagLabel">
						{labelText}
					</span>
				);
			})}
		</div>
	);
};

export default ItemTagLabels;
